import { useQueryClient } from '@tanstack/react-query';

import { client } from '@@api/client';
import { type Preference } from '@@api/services/auth/schemas';
import { useSettingsStore } from '@@scripts/store/settings/useSettingsStore';
import { useAuthStore } from '@@scripts/store/useAuthStore';

const useHandleUserChange = () => {
    const userId = useAuthStore((state) => state.userId);

    const hydrateSettings = useSettingsStore((s) => s.hydrateSettings);

    const dispatchPreferences = (preferences?: Preference) => {
        if (preferences) {
            hydrateSettings({
                contentLocale: preferences.contentLocale,
                betaFeaturesEnabled: preferences.betaFeaturesEnabled,
                collapsing: preferences.collapsing,
                filters: preferences.filters,
                uiLocale: preferences.uiLocale,
            });
        }
    };

    const queryClient = useQueryClient();

    const fetchPreferences = () =>
        queryClient.query(
            client.auth.users.preference.get.fetchQueryOptions({
                params: { id: userId! },
            }),
        );

    return { fetchPreferences, dispatchPreferences };
};

export default useHandleUserChange;
